import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import moment from 'moment';

import {
    getInvoiceDetailsComments,
    setInvoiceDetailsError,
    insertInvoiceDetailsComments,
    resetInvoiceComments
} from "../../../../constants/model-reducers/external/invoice/invoice/invoice-comments.settings";
import { httpGet, httpPost, httpPostFile, httpDownload } from "../../../../utils/api.utils";
import { convertToLocalDateToUTCDate, getLocalTimeZone } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    InvoiceDetailsComments: [],
    pageIndex: 1,
    hasMoreData: false
});

const initialState = defaultState();

export const invoiceCommentActions = {
    postInvoiceDetailsComments: (invoiceID, filename, fileData, comment, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const timezoneOffset = new Date().getTimezoneOffset() * -1;

        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("InvoiceID", invoiceID);

        var res = await httpPostFile(`external/invoice/setInvoiceDetailComments/${pageIndex}/${pageSize}?timeZoneOffset=${timezoneOffset}`,
            formData);

        if (res != null) {
            dispatch({
                type: insertInvoiceDetailsComments,
                InvoiceDetailsComments: res?.comments,
                isInvoiceCommentLoaded: true,
                isInvoiceCommentError: false
            });
        } else {
            dispatch({
                type: setInvoiceDetailsError,
                isInvoiceCommentError: true,
                isInvoiceCommentLoaded: false
            });
        }
    },

    getInvoiceDetailsComments: (invoiceID, pageIndex = 1, pageSize = 5) => async (dispatch, state) => {
        const existingInvoiceComments = state().invoiceInvoiceComments.InvoiceDetailsComments;
        const lastCommentId = existingInvoiceComments.length > 0
            ? existingInvoiceComments[existingInvoiceComments.length - 1].CommentID
            : null;

        const timezoneOffset = new Date().getTimezoneOffset() * -1;
        var res = await httpGet(
            `external/invoice/getInvoiceDetailComments/${pageIndex}/${pageSize}?invoiceID=${invoiceID}&timeZoneOffset=${timezoneOffset}` +
            (lastCommentId != null ? `&lastCommentId=${lastCommentId}` : "")
        );

        if (res != null) {
            dispatch({
                type: getInvoiceDetailsComments,
                InvoiceDetailsComments: res.comments,
                isInvoiceCommentLoaded: true,
                isInvoiceCommentError: false,
                pageIndex: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setInvoiceDetailsError,
                isInvoiceCommentError: true,
                isInvoiceCommentLoaded: false
            });
        }
    },

    clearInvoiceComments: () => async (dispatch, state) => {
        dispatch({
            type: resetInvoiceComments,
            InvoiceDetailsComments: [],
        })
    },

    deleteInvoiceDetailsComments: (commentId) => async (dispatch, state) => {
        const userId = sessionStorage.getItem("UserID")
        const res = await httpPost(`external/invoice/invoiceDeleteComment/` + commentId + '/' + userId);

        if (res != null) {
            dispatch({
                type: setInvoiceDetailsError,
                isInvoiceCommentError: true,
                isInvoiceCommentLoaded: false
            });
        }
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceDetailsComments: {
            return {
                ...state,
                InvoiceDetailsComments: [
                    ...state.InvoiceDetailsComments,
                    ...action.InvoiceDetailsComments
                ],
                hasMoreComments: action.hasMoreData,
                pageIndex: action.pageIndex
            };
        }
        case setInvoiceDetailsError: {
            return {
                ...state,
                isInvoiceCommentError: action.isInvoiceCommentError,
                isInvoiceCommentLoaded: action.isInvoiceCommentLoaded
            }
        }
        case insertInvoiceDetailsComments: {

            const combinedComments = [
                ...action.InvoiceDetailsComments,
                ...state.InvoiceDetailsComments
                ];

            const currentVisibleCount = state.InvoiceDetailsComments.length;
                const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
                const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;
                let updatedComments;
                if (hasMore) {
                    updatedComments = combinedComments.slice(0, -1);
                } else {
                    updatedComments = combinedComments;
                }

                return {
                    ...state,
                    InvoiceDetailsComments: combinedComments.length === 1 ? action.InvoiceDetailsComments : updatedComments,
                    hasMoreComments: hasMore,
            }
        }
        case resetInvoiceComments: {
            return {
                ...state,
                InvoiceDetailsComments: action.InvoiceDetailsComments,
                hasMoreComments: false,
                pageIndex: 1
            }
        }
        default:
            return state;
    }
}